var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankDocumentHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 23 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 3v4c0 .55228475-.44771525 1-1 1h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.167 21h-3.167c-1.1045695 0-2-.8954305-2-2v-11.17127c0-.53062686.21078944-1.03952086.586-1.41473l2.828-2.828c.37520914-.37521056.88410314-.586 1.41473-.586h8.17127c1.1045695 0 2 .8954305 2 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.01517 15.1225v4.8775c0 .5522847.4477153 1 1 1h6.05965c.5522847 0 1-.4477153 1-1v-4.7997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 15.9999964-4.34606-3.7565464c-.3755369-.3246048-.9323431-.3246048-1.30788 0l-4.34606 3.7565464"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24 24h-24v-24h24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankDocumentHouse);
export default __webpack_public_path__ + "static/media/blank-document-house.1991aa8daf625ca43f1d58709a909bac.svg";
export { ForwardRef as ReactComponent };